import { Box } from '@mui/material';

// Decoração do fundo do tema Ocean — mesma filosofia da LoginTechDecoration/
// PDVBasicoDecoration (100% CSS/MUI, sem imagem): linhas diagonais bem
// discretas nos cantos e grade de pontos esmaecendo nas bordas (mask). O
// gradiente de base (dois brilhos radiais em ciano + diagonal escuro
// azul-petróleo→teal) fica em PDVThemes.ts (colors.backgroundImage do tema
// 'ocean') — aqui só a camada que depende de mask-image, que um
// background-image comum não consegue expressar.
export const PDVOceanDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Linhas diagonais bem sutis nos cantos superior-esquerdo/inferior-direito. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: `
          linear-gradient(135deg, transparent 0 8%, rgba(55, 211, 221, 0.035) 8% 13%, transparent 13% 100%),
          linear-gradient(315deg, transparent 0 8%, rgba(55, 211, 221, 0.04) 8% 14%, transparent 14% 100%)
        `,
      }}
    />

    {/* Grade de pontos em ciano — esmaece nas bordas (mask), diagonal como as linhas acima. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.45,
        backgroundImage: 'radial-gradient(circle, rgba(67, 211, 220, 0.22) 1.4px, transparent 1.6px)',
        backgroundSize: '20px 20px',
        maskImage: 'linear-gradient(135deg, black 0%, transparent 22%, transparent 78%, black 100%)',
        WebkitMaskImage: 'linear-gradient(135deg, black 0%, transparent 22%, transparent 78%, black 100%)',
      }}
    />
  </Box>
);
